import { Component } from '@angular/core';
import {FirebaseService} from './firebase.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles: []
})
export class HomeComponent {
  constructor(public service: FirebaseService) { }
}
